export default {
    parts: ['container', 'title', 'table', 'th', 'tr', 'td'],
    baseStyle: {
        container: {
            width: '100%',
            overflowX: 'auto'
        },
        title: {
            textStyle: 'webH4',
            mb: 4
        },
        table: {
            width: '100%',
            borderCollapse: 'collapse',
            borderSpacing: 0
        },
        th: {
            textStyle: 'bodySmBold',
            textAlign: 'left',
            px: 4,
            py: 3,
            border: '1px solid',
            borderColor: 'webTheme.strokeTertiary'
        },
        tr: {},
        td: {
            textStyle: 'bodySmRegular',
            textAlign: 'left',
            px: 4,
            py: 3,
            verticalAlign: 'top',
            border: '1px solid',
            borderColor: 'webTheme.strokeTertiary'
        }
    }
}
